"use strict";
// Typography overrides for the Quicken theme.
Object.defineProperty(exports, "__esModule", { value: true });
function createTypography(palette) {
    return {
        caption: {
            letterSpacing: 'normal',
            color: palette.text.primary,
        },
        overline: {
            lineHeight: 1.66,
        },
        subtitle1: {
            fontWeight: 500,
        },
        h5: {
            fontWeight: 500,
        },
        h6: {
            color: palette.text.primary,
        },
    };
}
exports.default = createTypography;
